<template>
  <div>
    <div class="login-block">
      <LoadingSpinner v-if="cargando" />
      <div class="row">
        <div class="container container-login">
          <div class="row">
            <div class="col-md-12 login-sec">
              <h2 class="text-center">
                <img src="/img/Logo-STS.png" alt="" style="width: 180px" />
              </h2>
              <div class="text-center">
                <span
                  class="font-weight-bold text-center"
                  style="font-size: 14px"
                >
                  <b> Sistema de Transporte S.A. </b>
                </span>
              </div>
              <hr />
              <form @submit.prevent="login">
                <div class="input-group mb-3">
                  <input
                    type="email"
                    class="form-control"
                    v-model="form.email"
                    placeholder="Email"
                    :class="$v.form.email.$invalid ? 'is-invalid' : 'is-valid'"
                    autocomplete="off"
                  />
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span class="fas fa-envelope"></span>
                    </div>
                  </div>
                </div>
                <div class="input-group mb-3">
                  <input
                    type="password"
                    class="form-control"
                    v-model="form.password"
                    placeholder="Password"
                    :class="
                      $v.form.password.$invalid ? 'is-invalid' : 'is-valid'
                    "
                    autocomplete="off"
                  />
                  <div class="input-group-append">
                    <div class="input-group-text">
                      <span class="fas fa-lock"></span>
                    </div>
                  </div>
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" />
                    <small>Recordarme</small>
                  </label>
                  <button
                    type="submit"
                    class="btn btn-login float-right"
                    v-show="!$v.form.$invalid"
                  >
                    Ingresar
                  </button>
                </div>

                <div class="input-group mb-3">
                  <router-link to="/ForgotPassword"
                    >Deseo recordar mi contraseña</router-link
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required, email } from "vuelidate/lib/validators";
import LoadingSpinner from "../components/LoadingSpinner";

export default {
  components: {
    LoadingSpinner,
  },
  name: "LoginForm",
  data: () => ({
    user: {},
    form: {
      email: "",
      password: "",
    },
    cargando: false,
  }),

  validations: {
    form: {
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },

  methods: {
    async login() {
      this.cargando = true;
      await this.$store.dispatch("login", this.form);
      if (this.$store.getters.isAuthenticated) {
        this.cargando = false;
        return this.$router.replace("/");
      } else {
        this.cargando = false;
        /* console.log(this.$store.getters.getErrors); */
        if (this.$store.getters.getErrors == "password_updated_at") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Ha pasado mucho tiempo sin actualizar la contraseña, por favor cámbiela!",
          });
          this.$store.commit("SET_ERRORS", null);
          return this.$router.push({
            name: "ResetPassword",
            params: {
              token: "token",
              email: this.form.email,
            },
          });
        } else if (this.$store.getters.getErrors === "recaptcha") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Lo sentimos, pero las credenciales que has proporcionado son incorrectas. Por favor, verifica la información ingresada e inténtalo nuevamente.",
          });
        } else if (this.$store.getters.getErrors === "status") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Lo sentimos, pero las credenciales que has proporcionado son incorrectas. Por favor, verifica la información ingresada e inténtalo nuevamente.",
          });
        } else if (this.$store.getters.getErrors === "email") {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: this.$store.getters.getMensajeLogin,
          });
        } else {
          this.$swal({
            icon: "error",
            title: "Oops...",
            text: "Lo sentimos, pero las credenciales que has proporcionado son incorrectas. Por favor, verifica la información ingresada e inténtalo nuevamente.",
          });
        }
      }
    },
  },
  created() {
    if (this.$store.getters.isAuthenticated) {
      return this.$router.replace("/");
    }
  },
};
</script>

<style>
.login-block {
  background: #8fc74b;
  background: -webkit-linear-gradient(to bottom right, #05a85a, #8fc74b);
  background: linear-gradient(
    to bottom right,
    #05a85a,
    #8fc74b
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  float: left;
  width: 100%;
  padding: 50px 0;
  height: 100%;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-sec {
  padding: 50px 30px 10px 30px;
  position: relative;
}
.login-sec .copy-text {
  position: absolute;
  width: 80%;
  bottom: 20px;
  font-size: 13px;
  text-align: center;
}
.login-sec .copy-text i {
  color: #05a85a;
}
.login-sec .copy-text a {
  color: #8fc74b;
}
.login-sec h2 {
  margin-bottom: 12px;
  font-weight: 800;
  font-size: 30px;
  color: #001871;
}
.login-sec h2:after {
  content: " ";
  width: 164px;
  height: 4px;
  background: #8fc74b;
  display: block;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
}

.btn-login {
  background: linear-gradient(to bottom right, #05a85a, #8fc74b);
  color: #fff;
  font-weight: 600;
}

.container-login {
  background: #fff;
  border-radius: 10px;
  box-shadow: 15px 20px 0px rgba(0, 0, 0, 0.1);
}
</style>
